import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal, InputGroup } from "react-bootstrap";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";
//import classes from "../../Styles/common.module.css";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const RegisterSystem = (props) => {
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);

	const systemInputRef = useRef();
	const remarkInputRef = useRef();

	const [dataToBeSelect, setDataToBeSelect] = useState([]);

	const [addData, setAddData] = useState([]);
	const [inputError, setInputError] = useState([]);

	// 🔥 ATTACHMENT STATE
	const [selectedFiles, setSelectedFiles] = useState([]);

    const hideModal = () => {
		setAddData([]);
		setInputError([]);
		setSelectedFiles([]); // 🔥 IMPORTANT
		props.onHide();
	};

	const selectFileHandler = (event) => {
		const file = event.target.files[0];
		if (!file) return;

		if (file.size > 4 * 1024 * 1024) {
			toast.error("File exceeds 4MB.");
			return;
		}

		setSelectedFiles([{
			name: file.name,
			size: file.size,
			file: file
		}]);
	};

	const saveBtnOnClick = () => {
		var flag = true;
		if (!addData.SYSTEM_MST_NAME || addData.SYSTEM_MST_NAME.trim() === "") {
			flag = false;
			setInputError((prevState) => ({
				...prevState,
				SYSTEM_MST_NAME: "System name could not be empty.",
			}));
		}
        if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
			RegisterSystem();
		}
	}

    function RegisterSystem() {
		props.onLoading(true, "Registering system...");

		if (!addData.SYSTEM_MST_NAME || addData.SYSTEM_MST_NAME.trim() === "") {
			toast.error("System name is required.");
			props.onLoading(false);
			return;
		}

		// WITH FILE
		if (selectedFiles.length > 0) {
			const formData = new FormData();
			formData.append("SYSTEM_MST_NAME", addData.SYSTEM_MST_NAME.trim());
			formData.append("REMARK", addData.REMARK || "");
			formData.append("UPDATE_ID", userId);

			formData.append("file", selectedFiles[0].file);

			http.post("api/SystemSetup/RegisterSysWithAttachment", formData)
				.then(() => {
					toast.success("System inserted.");
					props.onReload();
					hideModal();
				})
				.catch((err) => {
					toast.error(err.response?.data?.MESSAGE || "Insert failed");
				})
				.finally(() => props.onLoading(false));
		}
		// WITHOUT FILE
		else {
			http.post("api/SystemSetup/RegisterSys", {
				SYSTEM_MST_NAME: addData.SYSTEM_MST_NAME.trim(),
				REMARK: addData.REMARK || "",
				UPDATE_ID: userId,
				FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			})
			.then(() => {
				toast.success("System inserted.");
				props.onReload();
				hideModal();
			})
			.catch(() => toast.error("Insert failed"))
			.finally(() => props.onLoading(false));
		}
	}

    const inputRequiredHandler = (event) => {
		let functionName = "";

		try {
			functionName = inputRequiredHandler.name;
			const name = event.target.name;
			functionName = inputRequiredHandler.name + "_" + name;
			const id = event.target.id;
			const val = event.target.value;
			//if (val.length === 0 || val.trim().length === 0) {
                if (val.length === 0) {
				setInputError((prevState) => ({
					...prevState,
					[id]: (name + " could not be empty."),
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					[id]: (""),
				}));
			}
			setAddData((prevState) => ({
				...prevState,
				[id]: val,
			}));
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	}

	const inputUnrequiredHandler = (event) => {
		let functionName = "";

		try {
			functionName = inputUnrequiredHandler.name;
			const name = event.target.name;
			functionName = inputUnrequiredHandler.name + "_" + name;
			const id = event.target.id;
			const val = event.target.value;

			setAddData((prevState) => ({
				...prevState,
				[id]: val,
			}));
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	}

    return (
		<>
			<Modal show={props.showHide} onHide={hideModal} centered>
				<Modal.Header>
					<div style={{ backgroundColor: "lightgrey", width: "100%" }}>
						<Modal.Title>REGISTER</Modal.Title>
					</div>
				</Modal.Header>
				<Modal.Body>
					<Comp.Input
						ref={systemInputRef}
						id="SYSTEM_MST_NAME"
						label="System Name*:"
						name="System Name"
						type="text"
						className="form-control"
						errorMessage={inputError.SYSTEM_MST_NAME}
						value={addData.SYSTEM_MST_NAME}
						onChange={inputRequiredHandler}
					/>
                    <Comp.Input
						ref={remarkInputRef}
						id="REMARK"
						label="Remark:"
						type="text"
						className="form-control"
						value={addData.REMARK}
						onChange={inputUnrequiredHandler}
					/>
					<input
						id="ATTACHMENT"
						type="file"
						style={{ display: "none" }}
						onChange={selectFileHandler}
						accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png,.txt"
					/>

					<div style={{ marginTop: "15px" }}>
						<div style={{ marginBottom: "8px", fontWeight: "500" }}>
							Upload File (Max. 4MB)
						</div>

						{/* Upload button */}
						{selectedFiles.length === 0 && (
							<Comp.Button onClick={() => document.getElementById("ATTACHMENT").click()}>
								Upload File
							</Comp.Button>
						)}

						{/* File display */}
						{selectedFiles.length > 0 && (
							<div style={{
								marginTop: "10px",
								padding: "8px",
								border: "1px solid #ddd",
								borderRadius: "5px",
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center"
							}}>
								<span>{selectedFiles[0].name}</span>
								<button
									style={{ border: "none", background: "none" }}
									onClick={() => setSelectedFiles([])}
								>
									<CloseRoundedIcon />
								</button>
							</div>
						)}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div style={{ textAlign: "center", width: "100%" }}>
						<Comp.Button id="btnSave" onClick={saveBtnOnClick}>
							Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
						</Comp.Button>
						&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
						<Comp.Button
							id="btnCancel"
							type="cancel"
							onClick={hideModal}
						>
							Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
						</Comp.Button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default RegisterSystem;